import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./hooks/authContext";
import { CityProvider } from "./hooks/cityContext"; // ✅ Import CityProvider
import { ThemeProvider } from "@mui/material/styles"; 
import theme from "./theme"; // Import the MUI theme
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";

import { EditIdProvider } from "./hooks/editProperty";
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Router>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <CityProvider> 
            <EditIdProvider>
            <ThemeProvider theme={theme}> 
              <App />
            </ThemeProvider>
            </EditIdProvider>
          </CityProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Router>
);
